module.exports = __webpack_public_path__ + "img/num-03.00ab123c.png";